import type { Course, Unit } from "../types/learning";

export const courses: Course[] = [
  {
    id: "es-en",
    target: "es",
    base: "en",
    level: "A2",
    progress: 62,
    unit: 4,
    lesson: 3,
    wordsLearned: 412,
    lastStudied: "2 hours ago",
    weekXp: [40, 55, 20, 0, 65, 30, 35],
    skills: { vocab: 72, listening: 58, speaking: 34, grammar: 61, reading: 66 },
    bookPage: 2,
  },
  {
    id: "es-ru",
    target: "es",
    base: "ru",
    level: "A1",
    progress: 28,
    unit: 2,
    lesson: 2,
    wordsLearned: 96,
    lastStudied: "Yesterday",
    weekXp: [10, 0, 25, 15, 0, 20, 0],
    skills: { vocab: 40, listening: 30, speaking: 18, grammar: 26, reading: 35 },
    bookPage: 0,
  },
  {
    id: "de-en",
    target: "de",
    base: "en",
    level: "A1",
    progress: 45,
    unit: 3,
    lesson: 4,
    wordsLearned: 188,
    lastStudied: "4 days ago",
    weekXp: [15, 20, 0, 10, 0, 0, 0],
    skills: { vocab: 52, listening: 41, speaking: 22, grammar: 38, reading: 47 },
    bookPage: 1,
  },
];

export const units: Unit[] = [
  {
    number: 1,
    title: "First words",
    description: "Say hello, introduce yourself and count to ten.",
    lessons: [
      { id: "u1-l1", title: "Hello & goodbye", kind: "lesson" },
      { id: "u1-l2", title: "My name is…", kind: "lesson" },
      { id: "u1-l3", title: "Numbers 1–10", kind: "lesson" },
      { id: "u1-l4", title: "Meeting Lucía", kind: "story" },
      { id: "u1-l5", title: "Unit review", kind: "review" },
    ],
  },
  {
    number: 2,
    title: "At the café",
    description: "Order drinks, ask for the bill and be polite about it.",
    lessons: [
      { id: "u2-l1", title: "Drinks", kind: "lesson" },
      { id: "u2-l2", title: "Ordering", kind: "lesson" },
      { id: "u2-l3", title: "The bill, please", kind: "lesson" },
      { id: "u2-l4", title: "A busy morning", kind: "story" },
      { id: "u2-l5", title: "Unit review", kind: "review" },
    ],
  },
  {
    number: 3,
    title: "Getting around",
    description: "Ask for directions, buy tickets and read signs.",
    lessons: [
      { id: "u3-l1", title: "Left & right", kind: "lesson" },
      { id: "u3-l2", title: "Where is…?", kind: "lesson" },
      { id: "u3-l3", title: "At the station", kind: "lesson" },
      { id: "u3-l4", title: "Tickets", kind: "lesson" },
      { id: "u3-l5", title: "Lost in town", kind: "story" },
      { id: "u3-l6", title: "Unit review", kind: "review" },
    ],
  },
  {
    number: 4,
    title: "At the market",
    description: "Fruit, quantities and haggling like a local.",
    lessons: [
      { id: "u4-l1", title: "Fruit & veg", kind: "lesson" },
      { id: "u4-l2", title: "How much?", kind: "lesson" },
      { id: "u4-l3", title: "Buying fruit", kind: "lesson" },
      { id: "u4-l4", title: "Quantities", kind: "lesson" },
      { id: "u4-l5", title: "Saturday shopping", kind: "story" },
      { id: "u4-l6", title: "Unit review", kind: "review" },
    ],
  },
  {
    number: 5,
    title: "Family & home",
    description: "Talk about the people you live with and the rooms you share.",
    lessons: [
      { id: "u5-l1", title: "My family", kind: "lesson" },
      { id: "u5-l2", title: "Rooms", kind: "lesson" },
      { id: "u5-l3", title: "Chores", kind: "lesson" },
      { id: "u5-l4", title: "Sunday lunch", kind: "story" },
      { id: "u5-l5", title: "Unit review", kind: "review" },
    ],
  },
];
